import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { rootRoute } from '../../router/routes/rootRoute';

export const homeRouteSearchSchema = z
	.object({
		shouldRedirectToMicrosoftLogin: z.boolean().optional(),
	})
	.prefault({});

export const homeRoute = createRoute({
	path: '/',
	getParentRoute: () => rootRoute,
	component: lazyRouteComponent(() => import('./HomePage'), 'HomePage'),
	validateSearch: homeRouteSearchSchema,
});
